/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-11-14 16:42:39
 * @LastEditors: WangYuhan
 */
import Layout from '@/layout';

const paymentRouter = {
  path: `/payment`,
  component: Layout,
  redirect: `/payment/payFreight`,
  alwaysShow: true, // will always show the root menu
  name: 'Payment',
  meta: {
    id: 4,
    title: '支付管理',
    icon: 'yzs_zhifuguanli',
    roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE'],
  },
  children: [
    {
      path: 'payFreight',
      component: () => import('@/views/payment/payFreight'),
      name: 'PayFreight',
      meta: {
        id: 41,
        title: '支付运费',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE'],
      },
    },
    {
      path: 'payOil',
      component: () => import('@/views/payment/payOil'),
      name: 'PayOil',
      meta: {
        id: 42,
        title: '支付油款',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE'],
      },
    },
    {
      path: 'payOilStep',
      component: () => import('@/views/payment/payOilStep'),
      name: 'payOilStep',
      pattern: 'account',
      meta: {
        id: 43,
        title: '分油审核',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE'],
      },
    },
    // {
    //   path: 'serviceChargeBack',
    //   component: () => import('@/views/payment/serviceChargeBack'),
    //   name: 'ServiceChargeBack',
    //   meta: {
    //     id: 63,
    //     title: '服务费返还',
    //     roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE'],
    //   },
    // },

    {
      path: 'payFreight/monthBill',
      name: 'PayFreightMonthBill',
      component: () => import('@/views/payment/payFreight/monthBill/index.vue'),
      hidden: true,
      meta: {
        id: 611,
        title: '月账单',
        parent: {
          path: '/payment/payFreight',
          meta: {
            id: 61,
            title: '支付运费',
          },
        },
      },
    },

    {
      path: 'paySubsidy',
      component: () => import('@/views/payment/paySubsidy'),
      name: 'paySubsidy',
      pattern: 'account',
      meta: {
        id: 44,
        title: '补贴油款钱包',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE'],
      },
    },
    {
      path: 'payDriver',
      component: () => import('@/views/payment/payDriver'),
      name: 'PayDriver',
      pattern: 'account',
      meta: {
        id: 45,
        title: '司机油款钱包',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE'],
      },
    },
  ],
};
export default paymentRouter;
